import projectMgmtSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const projectMgmtActions = { ...actions, ...thunkActions };
export * as ProjectMgmtTypes from './types';
export default projectMgmtSlice;
